"use client"

import { useEffect, useState } from 'react'

/**
 * Beta tag component that displays when RUN_ENV is set to 'beta'
 * Shows in the top right corner of the screen
 */
export function BetaTag() {
  const [isBeta, setIsBeta] = useState(false)

  useEffect(() => {
    // Check if we're in beta environment
    // This will be set from the server component
    const betaMode = document.documentElement.getAttribute('data-beta-mode') === 'true'
    setIsBeta(betaMode)
  }, [])

  if (!isBeta) return null

  return (
    <div className="fixed top-4 right-4 z-50 bg-yellow-500 text-black px-3 py-1 rounded-full text-sm font-bold shadow-lg">
      BETA
    </div>
  )
}